export const MAIN_PALETTE = {
  c900: '#2A0548 ',
  c800: '#460878',
  c700: '#5E1999',
  c600: '#7C12D3',
  c500: '#912FEA',
  c400: '#A855F7',
  c300: '#C084FC',
  c200: '#DDBEFE',
  c100: '#F2E5FF',
  c050: '#FAF5FF',
};

export const NEUTRAL_PALETTE = {
  c900: '#141216',
  c800: '#29272A',
  c700: '#433F46',
  c600: '#57525B',
  c500: '#76717A',
  c400: '#A5A1AA',
  c300: '#D6D4D8',
  c200: '#E5E4E7',
  c100: '#F5F4F5',
  c050: '#FAFAFA',
};
